export default __webpack_public_path__ + "static/media/Spiderman_08.bd79038e.png";